const LOGIN_REQUEST = "LOGIN_REQUEST";
const LOGIN_ERROR = "LOGIN_ERROR";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";

export {
    LOGIN_ERROR,
    LOGIN_SUCCESS,
    LOGIN_REQUEST,
    LOGOUT
}